import { render, staticRenderFns } from "./MotorcycleInsuranceForm.vue?vue&type=template&id=e949a972"
import script from "./MotorcycleInsuranceForm.vue?vue&type=script&lang=js"
export * from "./MotorcycleInsuranceForm.vue?vue&type=script&lang=js"
import style0 from "./MotorcycleInsuranceForm.vue?vue&type=style&index=0&id=e949a972&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports